export const GET_CONVERSATION_DETAILS_RECORDING_AND_TRANSCRIPT =
  'getConversationDetailsRecordingAndTranscript';
